import { render, staticRenderFns } from "./ArchivedProjects.vue?vue&type=template&id=4863fad9&"
import script from "./ArchivedProjects.vue?vue&type=script&lang=js&"
export * from "./ArchivedProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports